(function() {
  'use strict';
  // Sets site theme according to user preference
  angular.module('ringbaPortal').directive('themeCheck', themeCheck);

  function themeCheck(
    accountsService,
    userSettingsService,
    whitelabelService,
    whitelabelManager,
  ) {
    'ngInject';

    const directive = {
      restrict: 'A',
      link: link
    };

    return directive;

    function link() {
      init();

      function init() {
        whitelabelService.checkIfSiteIsWhitelabelled(accountsService.currentAccountId).then(function(isWhitelabelled) {
          if (!isWhitelabelled) {
            _setTheme();
          }
        });
      }

      function _setTheme() {
        userSettingsService.getUserSettings()
          .then(function(userSettings) {
            whitelabelManager.applyTheme(userSettings.isLightTheme || false, true);
          });
      }

    }
  }
})();
